import * as R from "ramda";

export const responseUnnestData = response => {
  const nestedData = R.path(["data", "data"], response);
  if (nestedData) {
    response.data = nestedData;
  }
  return response;
};



// WEBPACK FOOTER //
// ./src/services/api/transformers.js